import { spacing, spacingBreakpointUnits } from '../../defaultTheme';
import mediaQueries from '../../const/mediaQueries';
import setMediaQueryStyles from '../../helpers/mediaQuery';
const { lessThanMedium, betweenMediumLarge, greaterThanHuge } = mediaQueries;
export const getHideStyes = (hideOnBreakpointUp, hideOnBreakpointDown, hideOnlyOnBreakpoints, styles) => {
    let hideStyles = '';
    // Hide spacer on min-width
    if (hideOnBreakpointUp) {
        hideStyles += setMediaQueryStyles(hideOnBreakpointUp, styles);
    }
    // Hide spacer on max-width
    if (hideOnBreakpointDown) {
        hideStyles += setMediaQueryStyles(hideOnBreakpointDown, styles, 'max');
    }
    if (hideOnlyOnBreakpoints) {
        hideStyles += hideOnlyOnBreakpoints.map((breakpoint) => `@media ${mediaQueries[breakpoint]} { ${styles} }`);
    }
    return hideStyles;
};
export const getBreakpointSizing = (size, breakpoint, styles) => {
    const breakpointSpaceUnit = spacingBreakpointUnits[breakpoint];
    const adjustSize = size * breakpointSpaceUnit;
    const responsiveSizeStyle = styles.map((style) => `${style}: ${adjustSize}px;`);
    if (breakpoint === 'small') {
        return `@media ${lessThanMedium} {
      ${responsiveSizeStyle.join(' ')}
    }`;
    }
    if (breakpoint === 'medium') {
        return `@media ${betweenMediumLarge} {
      ${responsiveSizeStyle.join(' ')}
    }`;
    }
    // if all else fails, it's huge
    return `@media ${greaterThanHuge} {
    ${responsiveSizeStyle.join(' ')}
  }`;
};
export const getBreakpointInsetSizing = (sizes, breakpoint, styles) => {
    const breakpointSpaceUnit = spacingBreakpointUnits[breakpoint];
    const adjustSizes = sizes
        .map((size) => {
        const adjustSize = size * breakpointSpaceUnit;
        return `${adjustSize}px`;
    })
        .join(' ');
    const responsiveSizeStyle = styles.map((style) => `${style}: ${adjustSizes};`);
    switch (breakpoint) {
        case 'small':
            return `@media ${lessThanMedium} {
      ${responsiveSizeStyle.join(' ')}
    }`;
        case 'medium':
            return `@media ${betweenMediumLarge} {
      ${responsiveSizeStyle.join(' ')}
    }`;
        default:
            return `@media ${greaterThanHuge} {
      ${responsiveSizeStyle.join(' ')}
    }`;
    }
};
export const getResponsiveStyles = (size, styles, breakpoints) => {
    const spaceSize = spacing[size || 'base'];
    const responsiveStyles = breakpoints.map((breakpoint) => {
        return getBreakpointSizing(spaceSize, breakpoint, styles);
    });
    return responsiveStyles.join(' ');
};
